import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AxiosInstance from "../AxiosInstance";
import {
  FaHome, FaClipboardList, FaSignOutAlt, FaUserCircle, FaUser, FaUsers,
  FaFolder, FaCalendarWeek, FaChartBar, FaBars, FaFileAlt, FaClipboard
} from "react-icons/fa";
import '../../stylesheet.css';
import Footer from "../Footer";
import ToastNotification from "../ToastNotification";
import { adminMenuConfig } from "../menuconfig"; 

const Layout = ({ children, heading }) => {
  const [fullName, setFullName] = useState('');
  const [profileImage, setProfileImage] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(localStorage.getItem("sidebarOpen") === "true");
  const navigate = useNavigate();
  const location = useLocation();
  const toastRef = useRef(null);
  const imageUrl = process.env.REACT_APP_BASE_URL + '/uploads/';
  const userId = localStorage.getItem('employeeId');

  useEffect(() => {
    if (userId) {
      AxiosInstance.get(`/common/user/${userId}`)
        .then((response) => {
          setFullName(response.data.full_name);
          setProfileImage(imageUrl + response.data.image_profile);
        })
        .catch(() => {
          toastRef.current?.showToast('Error fetching user details:', "danger");
        });
    } else {
      toastRef.current?.showToast('User not logged in or userId not found.', "danger");
      navigate('/');
    }
  }, [userId, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('employeeId');
    navigate('/');
  };

  const handleHomeNavigation = () => navigate('/admin-dashboard');
  const handleAccountNavigation = () => navigate('/AdminAccount');

  const toggleSidebar = () => {
    setSidebarOpen((prev) => {
      const newState = !prev;
      localStorage.setItem("sidebarOpen", newState);
      return newState;
    });
  };

  return (
    <div className="page wrapper d-flex flex-column min-vh-100">
      <div className={`layout-container d-flex flex-grow-1 ${sidebarOpen ? '' : 'sidebar-closed'}`}>
        <div className={`sidebar ${sidebarOpen ? '' : 'collapsed'}`} onMouseEnter={() => setSidebarOpen(true)} onMouseLeave={() => setSidebarOpen(false)}>
          <div style={{ display: "flex" }}>
            <h4 className="text-left mb-4">FinGlider</h4>
            <button className="btn btn-link me-2 text-white" onClick={toggleSidebar} style={{ fontSize: '20px' }}>
              <FaBars />
            </button>
          </div>

          <nav className="nav flex-column">
            {adminMenuConfig.profile && (
              <Link to="/AdminProfile" className={`nav-link text-white d-flex align-items-center ${location.pathname === '/AdminProfile' ? 'active' : ''}`}>
                <FaUserCircle className="me-2" /> <span>Profile</span>
              </Link>
            )}
            {adminMenuConfig.employees && (
              <Link to="/employee-list" className={`nav-link text-white d-flex align-items-center ${location.pathname === '/employee-list' ? 'active' : ''}`}>
                <FaUsers className="me-2" /> <span>Employees</span>
              </Link>
            )}
            {adminMenuConfig.projects && (
              <Link to="/projects" className={`nav-link text-white d-flex align-items-center ${location.pathname === '/projects' ? 'active' : ''}`}>
                <FaFolder className="me-2" /> <span>Projects</span>
              </Link>
            )}
            {adminMenuConfig.timesheet && (
              <Link to="/timesheet" className={`nav-link text-white d-flex align-items-center ${location.pathname === '/timesheet' ? 'active' : ''}`}>
                <FaCalendarWeek className="me-2" /> <span>Timesheet</span>
              </Link>
            )}
            {adminMenuConfig.performance && (
              <Link to="/performance" className={`nav-link text-white d-flex align-items-center ${location.pathname === '/performance' ? 'active' : ''}`}>
                <FaChartBar className="me-2" /> <span>Performance</span>
              </Link>
            )}
            {adminMenuConfig.leaves && (
              <Link to="/AdminLeaves" className={`nav-link text-white d-flex align-items-center ${location.pathname === '/AdminLeaves' ? 'active' : ''}`}>
                <FaClipboardList className="me-2" /> <span>Leaves</span>
              </Link>
            )}
            {adminMenuConfig.reports && (
              <Link to="/Reports" className={`nav-link text-white d-flex align-items-center ${location.pathname === '/Reports' ? 'active' : ''}`}>
                <FaFileAlt className="me-2" /> <span>Reports</span>
              </Link>
            )}
            {adminMenuConfig.manageData && (
              <Link to="/edit-table" className={`nav-link text-white d-flex align-items-center ${location.pathname === '/edit-table' ? 'active' : ''}`}>
                <FaClipboard className="me-2" /> <span>Manage Data</span>
              </Link>
            )}
          </nav>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1">
          <div className="navbar-container">
            <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
              <div className="container-fluid d-flex justify-content-between align-items-center">
                <button className="btn btn-link text-dark" onClick={handleHomeNavigation}>
                  <FaHome />
                </button>
                <div className="dropdown">
                  <button className="btn btn-link" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                    {fullName}
                    {profileImage ? (
                      <img src={profileImage} alt="Profile" style={{ width: '30px', height: '30px', borderRadius: '50%' }} />
                    ) : (
                      <FaUserCircle style={{ width: '30px', height: '30px' }} />
                    )}
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <button className="dropdown-item d-flex align-items-center" onClick={handleAccountNavigation}>
                        <FaUser className="me-2" /> Account
                      </button>
                    </li>
                    <li>
                      <button className="dropdown-item d-flex align-items-center" onClick={handleLogout}>
                        <FaSignOutAlt className="me-2" /> Logout
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
          <div className="content flex-grow-1">
            <div className="content-container">
              <h4 style={{ fontSize: '20px', color: 'grey' }}>{heading}</h4>
              {children}
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ToastNotification ref={toastRef} />
    </div>
  );
};

export default Layout;
